module.exports = {
  tableName: "tbl_usermaster",
  usernameField: "email",
  passwordField: "password",
  userPlayerTableName: "tbl_userPlayeridMapping",
  fk_userID: "fk_userID",
  playerID: "playerID",
  DEPLOYMENT_TYPE: "AXIOM",
  timeoutMessage: 5 * 60 * 60 * 1000,
  timeoutExpire: 2 * 60 * 1000,
  timeoutDisconnect: 7 * 24 * 60 * 60 * 1000,
  sessionTimeOut: 5 * 60 * 60 * 1000,
  enableAppCache: false,
  enableMinify: false,
  isFacebookLoginAllowed: false,
  captchaEnabled: false,
  allowSignup: true,
  allowForgotPassword: true,
  customPageEnable: false,
  customPageURL: false,
  allowMultipleSession: false,
  activeUsers: {},
  activeConnectionStack: {},
  DIFF: "",
  loginAttempt: 0,
  requestTimeOut: 5 * 60 * 60 * 1000,
  tableSaveAPIStackSize: 100000,
  fileReadChunkSize: 25 * 1000 * 1000,
  guestUserID: -1,
  cassandraConfig: {
    type: "database",
    databaseType: "cassandra",
    connectionLimit: 20,
  },
  dbConfig: { type: "database", databaseType: "mysql" },
  tables_dbConfig: { type: "database", databaseType: "mysql" },
  uploadDir: "",
  logFileLocation: "",
  axiomAppsLocation: "",
  axiomComponentsLocation: "",
  mailConfig: {},
  otpConfig: {},
  applicationURL: "",
  kafkaURL: "",
  deploymentMode: "",
  eventProducerURL: "",
  alertEngineOutputFilePath: "",
  monitorLoginEnabled: "",
  other_login_options: "",
  FTPDirectory: "",
  scheduleScriptPath: "",
  pythonExecutablePath: "",
  PersonIdentificationDirectory: "",
  ruleProcessingEngineURL: "",
  needSandbox: true,
  cassandraTrendTable: "kpi_store_kpi_trend",
  cassandraDrillTable: "kpi_store_kpi_drill",
  accountSid: "ACeedcd01f7c09fdef12aadbac67818a15",
  authToken: "7d5d284c88e5230da7df84be1190950b",
  whatsappMsgFrom: "+14155238886",
  kpicalculatorStatusDB: "kpicalculator_status",
  platformBackendServices: "",
  externalFileSystemOptions: "",
  showActiveConnections: true,
};
